import { createPortal } from 'react-dom';

const CalendarContainerPortal = ({ children }) =>
  createPortal(children, document.getElementById('calendar-container'));

export default CalendarContainerPortal;
